import data from "bootstrap/js/src/dom/data";

export default class CostCategoryService {

  static apiRelativePath = "/cost-categories"

  constructor(apiClient) {
    this.apiClient = apiClient;
  }

  getAll = async () => {
    return this.apiClient.get(`${CostCategoryService.apiRelativePath}`);
  }

  create = async (data) => {
    return this.apiClient.post(`${CostCategoryService.apiRelativePath}`, data);
  }

  put = async (id, data) => {
    return this.apiClient.put(`${CostCategoryService.apiRelativePath}/${id}`, data);
  }

  delete = async (id) => {
    return this.apiClient.delete(`${CostCategoryService.apiRelativePath}/${id}`);
  }

  reorder = async (data) => {
    return this.apiClient.post(`${CostCategoryService.apiRelativePath}/reorder`, data);
  }
}
